/**
 * Admin Panel Script
 * Handles admin iframe communication and customer data exchange
 */

(function() {
  'use strict';

  /**
   * Setup postMessage listener for admin iframe communication
   */
  function setupAdminPostMessageListener() {
    window.addEventListener('message', function(event) {
      try {
        // Verify origin for security
        if (event.origin !== 'https://dkwc99m14r69.cloudfront.net') {
          return;
        }


        // Check if message type is admin_panel
        if (event.data && event.data.type === 'admin_panel') {
          
          // Send customer data to admin iframe
          sendCustomerDataToAdminIframe();
        }
      } catch (error) {
        console.error('Error in admin postMessage listener:', error);
      }
    });

    // Add error event listener for admin iframe
    const adminIframe = document.getElementById('sauna-iframe');
    if (adminIframe) {
      adminIframe.addEventListener('error', function(e) {
        console.error('Admin iframe error:', e);
      });

      adminIframe.addEventListener('load', function() {
        console.log('Admin iframe loaded successfully');
      });
    }
  }

  /**
   * Get customer data from iframe attributes
   */
  function getCustomerData() {
    const adminIframe = document.getElementById('sauna-iframe');
    
    if (!adminIframe) {
      return null;
    }

    // Get customer data from iframe data attributes only
    const customerEmail = adminIframe.getAttribute('data-customer-email');
    const customerTags = adminIframe.getAttribute('data-customer-tags');

    // Return only the basic customer data from data attributes
    let customerData = {
      email: customerEmail,
      tags: customerTags ? customerTags.split(',').map(tag => tag.trim()) : [],
      isAdmin: customerTags ? customerTags.includes('admin') : false,
      timestamp: new Date().toISOString()
    };

    return customerData;
  }

  /**
   * Send customer data to admin iframe
   */
  function sendCustomerDataToAdminIframe() {
    const customerData = getCustomerData();
    
    if (!customerData) {
      console.error('No customer data available');
      return;
    }

    const message = {
      type: 'CUSTOMER_DATA',
      customerData: customerData,
      source: 'shopify-admin-panel',
      timestamp: new Date().toISOString()
    };

    sendMessageToAdminIframe(message);
  }

  /**
   * Send message to admin iframe
   * @param {Object} message - Message to send to admin iframe
   */
  function sendMessageToAdminIframe(message) {
    const adminIframe = document.getElementById('sauna-iframe');
    
    if (adminIframe && adminIframe.contentWindow) {
      try {
        adminIframe.contentWindow.postMessage(message, 'https://dkwc99m14r69.cloudfront.net');
      } catch (error) {
        console.error('Error sending message to admin iframe:', error);
      }
    } else {
      console.error('Admin iframe not found or not ready');
    }
  }

  /**
   * Initialize admin panel functionality
   */
  function initAdminPanel() {
    // Only initialize if admin iframe exists
    let adminIframe = document.getElementById('sauna-iframe');
    adminIframe.src = 'https://dkwc99m14r69.cloudfront.net';
    if (adminIframe && adminIframe.src.includes('dkwc99m14r69.cloudfront.net')) {
      setupAdminPostMessageListener();
      
      // Send initial customer data after iframe loads
      adminIframe.addEventListener('load', function() {
        setTimeout(() => {
           sendCustomerDataToAdminIframe();
        }, 10);
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAdminPanel);
  } else {
    initAdminPanel();
  }

})();